import React from "react";
import NewsletterNine from "../component/NewsletterNine";

function NewsletterNineContainer() {
  return <NewsletterNine />;
}

export default NewsletterNineContainer;
